'use client';

import { Button } from '@common/components';
import dynamic from 'next/dynamic';

import { AddressInfoClient } from './AddressInfoClient';

const NaverMapClient = dynamic(
  () =>
    import('./NaverMapClient').then((mod) => ({
      default: mod.NaverMapClient,
    })),
  {
    ssr: false,
    loading: () => (
      <div className="flex h-300 w-full items-center justify-center rounded-large bg-Gray-900">
        <p className="font-500 text-Gray-550 typo-body3">지도 로딩 중...</p>
      </div>
    ),
  },
);

export const MapSection = () => {
  return (
    <section className="bg-Gray-black px-32 pb-80 pt-0">
      <div className="flex w-full flex-col gap-32">
        <h2 className="font-800 text-Gray-white typo-h4">오시는 길</h2>

        <div className="flex w-full flex-col gap-20">
          <NaverMapClient />

          <div className="flex w-full flex-col gap-32">
            <AddressInfoClient />

            <Button
              asChild
              theme="secondary-fill"
              dimensions="H48"
              className="w-full"
            >
              <a
                href="https://naver.me/57VZhxie"
                target="_blank"
                rel="noopener noreferrer"
              >
                길찾기
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};
